export const isHostOrSubdomain = (hostname: string, hosts: string[]): boolean =>
	hosts.some((host) => hostname === host || hostname.endsWith(`.${host}`));
